import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FEED, SPECIALIZATION } from "./RoutesUrl";
import { getUserData } from "./EncryptedLocalStorage";
const ProtectedRoute = (props) => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
      const checkUser = async() => {
    const userToken = await getUserData()
    if (userToken?.data?.id) {
      setIsLoggedIn(false);
      if (
        userToken?.data?.user_type === "doctor" &&
        userToken?.data?.subcategory === ""
      ) {
        return navigate(SPECIALIZATION);
      } else {
        return navigate(FEED);
      }
    }
    setIsLoggedIn(true);
  };
    checkUser();
  }, [isLoggedIn]);
  return <>{isLoggedIn ? props.children : null}</>;
};
export default ProtectedRoute;
